export default {
  titlePage: "ログイン",
  username: "ユーザー名",
  password: "パスワード",
  signIn: "ログイン",
  forgotPassword: "パスワードを忘れた場合はこちら",
  forgotPassTitle: "パスワードリセット",
  changePasswordTitle: "パスワードの変更",
  sendEmail: "送信",
  email: "ログインIDまたはメールアドレス",
  resetPass: "パスワード設定",
  oldPass: "現在パスワード",
  newPass: "新しいパスワード",
  reNewPass: "新しいパスワードを再入力",
  reset: "設定",
  changePasswordButton: "変更する",
};
